var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { Badge as XBadge, PrimaryBadge, SecondaryBadge, GreenBadge, RedBadge, WhiteBadge } from './Badge.styled';
import { outlinePrimary, outlineSecondary, outlineGreen, outlineRed, outlineWhite, outlineNeutral, compact, small, } from '../styles';
import { getAutomation, getDebug, getStyleNames } from '@citrus/runtime';
import { isNotNullOrEmpty, isNullOrEmpty } from '@pcty/utils';
var VERSION = '2.3.3';
var Badge = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, className = _a.className, color = _a.color, css = _a.css, _c = _a.outline, outline = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.value, value = _e === void 0 ? '' : _e, _f = _a.__TYPE, __TYPE = _f === void 0 ? 'Badge' : _f, other = __rest(_a, ["automationId", "className", "color", "css", "outline", "size", "value", "__TYPE"]);
    var emotionObj = (_b = {},
        _b[emotionCss(outlinePrimary)] = outline && color === 'primary',
        _b[emotionCss(outlineSecondary)] = outline && color === 'secondary',
        _b[emotionCss(outlineGreen)] = outline && color === 'green',
        _b[emotionCss(outlineRed)] = outline && color === 'red',
        _b[emotionCss(outlineWhite)] = outline && color === 'white',
        _b[emotionCss(outlineNeutral)] = outline && color === undefined,
        _b[emotionCss(small)] = isNotNullOrEmpty(value) && size === 'small',
        _b[emotionCss(compact)] = isNullOrEmpty(value),
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b);
    var classes = cx(emotionObj, className || '');
    var styleNames = {
        outlinePrimary: emotionObj[emotionCss(outlinePrimary)],
        outlineSecondary: emotionObj[emotionCss(outlineSecondary)],
        outlineGreen: emotionObj[emotionCss(outlineGreen)],
        outlineRed: emotionObj[emotionCss(outlineRed)],
        outlineWhite: emotionObj[emotionCss(outlineWhite)],
        outlineNeutral: emotionObj[emotionCss(outlineNeutral)],
        small: emotionObj[emotionCss(small)],
        compact: emotionObj[emotionCss(compact)],
    };
    var Badge = getComponent(color);
    return (React.createElement(Badge, __assign({ className: classes, ref: ref, styleNames: getStyleNames(styleNames) }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)), value));
});
var getComponent = function (color) {
    switch (color) {
        case 'primary':
            return PrimaryBadge;
        case 'secondary':
            return SecondaryBadge;
        case 'green':
            return GreenBadge;
        case 'red':
            return RedBadge;
        case 'white':
            return WhiteBadge;
        default:
            return XBadge;
    }
};
Badge.defaultProps = {
    __TYPE: 'Badge',
};
export default Badge;
